import React, { useEffect } from 'react';
import { ConnectButton, HeaderStyle, Logo, NavStyle, Address } from './Header.style';
import { colors, FlexRow } from "../../Global.style";
import openModal from "../openModal";
import ConnectWalletModal, { IConnectWalletModal } from '../connectWalletModal/ConnectWalletModal';
import { useWalletTools } from "../../hooks/useWalletTools";
import useRedux from "../../hooks/useRedux";
import { formatAddress } from "../../common/utilTools";
import Tooltip from "../tooltip/Tooltip";
import { RouterLink } from 'src/react-router/Index';

export default function Header() {
  const { storeData } = useRedux();
  const { connectStatus, disconnect, activate } = useWalletTools();

  useEffect(() => {
    if (storeData.wallet_info) {
      activate();
    }

  }, []);


  return (
    <HeaderStyle>
      <div style={{ display: "flex", alignItems: "center" }}>
        <a href={"http://dvol.finance/"} target={"_blank"}>
          <Logo src={require("src/assets/images/logo.png")}/>
        </a>
        <NavStyle>
        </NavStyle>
      </div>
      <FlexRow>
        {
          storeData.isAdmin
            ? <RouterLink to={"/trade"}>
                <span style={{color: colors.baseColor}}>Trade</span>
              </RouterLink>
            : null
        }
        <div style={{minWidth: "243px", textAlign: "right"}}>
          {
            storeData.address
              ? <Tooltip
                isH5={false}
                targetEl={<Address>{formatAddress(storeData.address)}</Address>}>
                <div style={{width: "120px", textAlign: "center", height: "100%", cursor: "pointer", fontSize: "16px"}}
                     onClick={disconnect}>Exit</div>
              </Tooltip>
              : <ConnectButton
                style={{  }}
                disabled={connectStatus}
                onClick={() => {
                  openModal<IConnectWalletModal>(ConnectWalletModal);
                }}>Connect Wallet</ConnectButton>
          }
        </div>
      </FlexRow>
    </HeaderStyle>
  )
}
